import { Component, ViewChild } from '@angular/core';
import { PoListViewAction, PoModalAction, PoModalComponent, PoMultiselectOption } from '@po-ui/ng-components';
import { QueryAnalyzerService } from './query-analyzer.service';
import { MainService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { NotificationServiceHM } from '../notification-item/notification-item.service'

@Component({
  selector: 'app-query-analyzer',
  templateUrl: './query-analyzer.component.html',
  styleUrls: ['./query-analyzer.component.css']
})
export class QueryAnalyzerComponent {

  @ViewChild('createAnalysis', {static: false}) createAnalysisModal: PoModalComponent;
  @ViewChild('deleteAnalysis', {static: false}) deleteAnalysisModal: PoModalComponent;

  testQuery: string = '';
  loading: Boolean;

  analyses: any[] = [];

  itemListOptions: Array<PoListViewAction> = [
      { label: 'Detalhes', action: this.detailsAnalysis.bind(this)},
      { label: 'Excluir', action: this.deleteAnalysis.bind(this)}
  ];

  constructor(
    public mainService: MainService, 
    private queryAnalyzerService: QueryAnalyzerService,
    public notificationServiceHM: NotificationServiceHM,
    public router: Router
  ) { }

  ngOnInit() {
    this.loading = true;

    this.queryAnalyzerService.getAnalyses().subscribe((response: any) => {
      this.analyses = response;
    });

    this.loading = false;
  }

  detailsAnalysis(item: any) {
    console.log('Details action triggered for item:', item);
    this.router.navigate(['/menu/query-analyzer/' + item.id]);
  }

  deleteAnalysis(item: any) {
    console.log('Delete action triggered for item:', item);
    this.toDelete = item;
    this.deleteAnalysisModal.open();
  }

  updateScreenData() {
    this.loading = true;
    this.queryAnalyzerService.getAnalyses().subscribe((response: any) => {
      this.analyses = response;
    });
    this.loading = false;
  }

  // Create Analysis Modal
    analysisModalCreate: PoModalAction = {
      action: () => {
        this.loading = true;
        this.createAnalysisModal.close();
        this.queryAnalyzerService.createAnalysis(this.testQuery).subscribe({
          next: ((response: any) => {
            console.log('Analysis created:', response);
            if (response.warnings !== "") {
              this.notificationServiceHM.showToast("Atenção: " + response.warnings, 'warning');
            } else {
              this.notificationServiceHM.showToast("Análise criada com sucesso", 'success');
            }
            this.updateScreenData();
          }),
          error: ((error: any) => {
            this.mainService.handleError(error)
            this.notificationServiceHM.showToast("Erro ao criar a Análise: " + error.error.message, "error");
          }),
        });
        this.testQuery = '';
        this.loading = false;
      },
      label: 'Criar',
    };
  

    // Delete Analysis Modal
    analysisModalCreateCancel: PoModalAction = {
      action: () => {
        this.createAnalysisModal.close();
      },
      label: 'Cancelar'
    };

    toDelete: any = {};
    canDelete: string = "NO";
    okDelete: PoModalAction = {
      action: () => {
        if (this.canDelete === "YES") {
          this.queryAnalyzerService.deleteAnalysis(this.toDelete.id).subscribe((response: any) => {
            console.log('Analysis deleted:', response);
            this.updateScreenData();
          });
          this.toDelete = {};
          this.canDelete = "NO";
          this.deleteAnalysisModal.close();
        } else {
          this.notificationServiceHM.showToast("Confirme se realmente deseja excluir a Análise", 'warning')
        }
      },
      label: 'Excluir'
    };

    cancelDelete: PoModalAction = {
      action: () => {
        this.deleteAnalysisModal.close();
      },
      label: 'Cancelar'
    };

}
